/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateEntitlementPayload } from '../model/createEntitlementPayload';
import { EntitlementData } from '../model/entitlementData';
import { EntitlementPrivilegeData } from '../model/entitlementPrivilegeData';
import { UpdateEntitlementPayload } from '../model/updateEntitlementPayload';
import { UpdatePrivilegePayload } from '../model/updatePrivilegePayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EntitlementService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create entitlement
     * 
     * @param payload Entitlement data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createEntitlement(payload?: CreateEntitlementPayload, observe?: 'body', reportProgress?: boolean): Observable<EntitlementData>;
    public createEntitlement(payload?: CreateEntitlementPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EntitlementData>>;
    public createEntitlement(payload?: CreateEntitlementPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EntitlementData>>;
    public createEntitlement(payload?: CreateEntitlementPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EntitlementData>(`${this.basePath}/api/entitlements`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete entitlement
     * 
     * @param entitlementId Entitlement
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEntitlement(entitlementId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEntitlement(entitlementId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEntitlement(entitlementId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEntitlement(entitlementId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (entitlementId === null || entitlementId === undefined) {
            throw new Error('Required parameter entitlementId was null or undefined when calling deleteEntitlement.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/entitlements/${encodeURIComponent(String(entitlementId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entitlements and privileges
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEntitlements(observe?: 'body', reportProgress?: boolean): Observable<EntitlementPrivilegeData>;
    public getEntitlements(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EntitlementPrivilegeData>>;
    public getEntitlements(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EntitlementPrivilegeData>>;
    public getEntitlements(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EntitlementPrivilegeData>(`${this.basePath}/api/entitlements`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update entitlement
     * 
     * @param entitlementId Entitlement
     * @param payload Entitlement data to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEntitlement(entitlementId: number, payload?: UpdateEntitlementPayload, observe?: 'body', reportProgress?: boolean): Observable<EntitlementData>;
    public updateEntitlement(entitlementId: number, payload?: UpdateEntitlementPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EntitlementData>>;
    public updateEntitlement(entitlementId: number, payload?: UpdateEntitlementPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EntitlementData>>;
    public updateEntitlement(entitlementId: number, payload?: UpdateEntitlementPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (entitlementId === null || entitlementId === undefined) {
            throw new Error('Required parameter entitlementId was null or undefined when calling updateEntitlement.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EntitlementData>(`${this.basePath}/api/entitlements/${encodeURIComponent(String(entitlementId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update privilege
     * 
     * @param privilegeId Privilege
     * @param payload Privilege data to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePrivilege(privilegeId: number, payload?: UpdatePrivilegePayload, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updatePrivilege(privilegeId: number, payload?: UpdatePrivilegePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updatePrivilege(privilegeId: number, payload?: UpdatePrivilegePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updatePrivilege(privilegeId: number, payload?: UpdatePrivilegePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (privilegeId === null || privilegeId === undefined) {
            throw new Error('Required parameter privilegeId was null or undefined when calling updatePrivilege.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/entitlements/privileges/${encodeURIComponent(String(privilegeId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
